import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { TourStep } from 'types/tour';

import { HOME } from 'constants/path';
import { tourInitialState } from 'constants/tour';

const tourSlice = createSlice({
  name: 'tour',
  initialState: tourInitialState,
  reducers: {
    startTour(
      state,
      action: PayloadAction<{
        steps: TourStep[];
        startPage?: string;
        isFullGuide: boolean;
      }>
    ) {
      return {
        ...state,
        run: true,
        stepIndex: 0,
        nextStepIndex: null,
        steps: action.payload.steps,
        currentPage: action.payload.startPage ?? HOME,
        tourActive: true,
        isOpenApplicationTour: false,
        isOpenJobTour: false,
        isFullGuide: action.payload.isFullGuide
      };
    },
    stopTour(state) {
      state.run = false;
      state.stepIndex = 0;
      state.nextStepIndex = null;
      state.tourActive = false;
      state.isOpenApplicationTour = false;
      state.isOpenJobTour = false;
      state.isFullGuide = false;
    },
    pauseTour(state) {
      state.run = false;
    },
    resumeTour(state) {
      state.run = true;
    },
    setStepIndex(state, action: PayloadAction<number>) {
      state.stepIndex = action.payload;
      state.nextStepIndex = null;
    },
    setCurrentPage(state, action: PayloadAction<string>) {
      state.currentPage = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    navigatePage(
      state,
      action: PayloadAction<{ page: string; stepIndex: number }>
    ) {
      state.currentPage = action.payload.page;
      state.stepIndex = action.payload.stepIndex;
      state.nextStepIndex = null;
      state.run = true;
    },
    setNextStepIndex(state, action: PayloadAction<number | null>) {
      state.nextStepIndex = action.payload;
    },
    setJobId(state, action: PayloadAction<{ jobId: string }>) {
      state.jobId = action.payload.jobId;
    },
    setApplicationId(state, action: PayloadAction<{ applicationId: string }>) {
      state.applicationId = action.payload.applicationId;
    },
    setIsOpenApplicationTour(state, action: PayloadAction<boolean>) {
      state.isOpenApplicationTour = action.payload;
    },
    setIsOpenJobTour(state, action: PayloadAction<boolean>) {
      state.isOpenJobTour = action.payload;
    },
    setSteps(state, action: PayloadAction<TourStep[]>) {
      state.steps = action.payload;
    }
  }
});

export const {
  startTour,
  stopTour,
  pauseTour,
  resumeTour,
  setStepIndex,
  setNextStepIndex,
  setCurrentPage,
  setLoading,
  navigatePage,
  setJobId,
  setApplicationId,
  setIsOpenApplicationTour,
  setIsOpenJobTour,
  setSteps
} = tourSlice.actions;

export default tourSlice.reducer;
